import React, { useState, useEffect } from "react";
import { Table, Tag, message, Empty } from "antd";
import { useDispatch, useSelector } from "react-redux";
import apiService from "../../services/api";
import {
  setLogs,
  setLoading,
  setError,
  selectTaskLogs,
  selectTaskLoading,
} from "../../store/taskSlice";
import { formatDateTime } from "../../utils/formatters";

const TaskLogs = ({ taskId }) => {
  const dispatch = useDispatch();
  const logs = useSelector(selectTaskLogs);
  const loading = useSelector(selectTaskLoading);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    if (taskId) {
      loadLogs();
    }
  }, [taskId]);

  const loadLogs = async () => {
    dispatch(setLoading(true));
    try {
      const params = {
        page: pagination.current,
        page_size: pagination.pageSize,
      };

      const response = await apiService.tasks.getTaskLogs(taskId, params);
      if (!response.data.success) {
        throw new Error(response.data.message || "获取日志失败");
      }

      dispatch(setLogs(response.data.data?.list || []));
      setPagination((prev) => ({
        ...prev,
        total: response.data.data?.total || 0,
      }));
    } catch (err) {
      message.error(err.message || "获取日志失败");
      dispatch(setError(err.message));
    }
  };

  const getStatusTag = (status) => {
    const colors = {
      running: "processing",
      success: "success",
      failed: "error",
    };
    const labels = {
      running: "运行中",
      success: "成功",
      failed: "失败",
    };
    return <Tag color={colors[status]}>{labels[status]}</Tag>;
  };

  const columns = [
    {
      title: "开始时间",
      dataIndex: "started_at",
      key: "started_at",
      width: 180,
      render: (text) => formatDateTime(text),
    },
    {
      title: "结束时间",
      dataIndex: "finished_at",
      key: "finished_at",
      width: 180,
      render: (text) => (text ? formatDateTime(text) : "-"),
    },
    {
      title: "状态",
      dataIndex: "status",
      key: "status",
      width: 100,
      render: (status) => getStatusTag(status),
    },
    {
      title: "耗时(秒)",
      dataIndex: "duration",
      key: "duration",
      width: 100,
      render: (duration) => (duration ? duration : "-"),
    },
    {
      title: "消息",
      dataIndex: "message",
      key: "message",
      ellipsis: true,
    },
  ];

  if (!taskId) {
    return <Empty description="请选择任务" />;
  }

  return (
    <Table
      columns={columns}
      dataSource={logs}
      rowKey="id"
      loading={loading}
      pagination={{
        ...pagination,
        showSizeChanger: true,
        showTotal: (total) => `共 ${total} 条`,
        onChange: (page, pageSize) => {
          setPagination((prev) => ({ ...prev, current: page, pageSize }));
          loadLogs();
        },
      }}
      expandable={{
        expandedRowRender: (record) =>
          record.details ? (
            <pre style={{ margin: 0, whiteSpace: "pre-wrap" }}>
              {record.details}
            </pre>
          ) : (
            <Empty description="无详细信息" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ),
      }}
    />
  );
};

export default TaskLogs;
